import { compose, withHandlers } from 'recompose';
import { withDataLayerPush } from '../withDataLayerPush';

// This push dataLayer by method
// eslint-disable-next-line
export const withDataLayerAddToCart = compose(
  withDataLayerPush,
  withHandlers({
    dataLayerAddToCart: ({ dataLayerPush }) => ({
      currencyCode, product, sourceOfAddingToCart = 'web'
    }) => {
      dataLayerPush({
        event: 'addToCart',
        ecommerce: {
          currencyCode,
          add: {
            products: [
              product
            ]
          }
        },
        sourceOfAddingToCart
      });
    }
  }),
);



// WEBPACK FOOTER //
// ./src/Common/GTM/ECommerceTracking/withDataLayerAddToCart.js